import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FooterComponent } from './layouts/footer/footer.component';
import { INgxLoadingConfig, NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { SpinnerService } from './core/services/spinner.service';
import { DevtoolsService } from './core/security/devtools.service';
import { isMobileDevice } from './core/security/device.util';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FooterComponent, NgxLoadingModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'grms-frontend';
  loading: boolean = false;

  loaderConfig: INgxLoadingConfig = {
    animationType: ngxLoadingAnimationTypes.circleSwish,
    backdropBackgroundColour: 'rgba(157, 161, 158,0.3)',
    fullScreenBackdrop: true,
    primaryColour: '#04A251',
    secondaryColour: '#04A251',
    tertiaryColour: '#04A251',
  };

  // Right-click: blocked on desktop only, not on editable fields so copy/paste still works.
  @HostListener('document:contextmenu', ['$event'])
  onRightClick(event: MouseEvent) {
    if (!environment.securityEnabled) return;
    if (isMobileDevice()) return;
    const target = event.target as HTMLElement;
    const tag = target.tagName.toLowerCase();
    const isEditable = tag === 'input' || tag === 'textarea' || target.isContentEditable;
    if (!isEditable) event.preventDefault();
  }

  private boundKeyHandler = this.handleKeyboardEvent.bind(this);

  private handleKeyboardEvent(event: KeyboardEvent): void {
    const key = event.key.toLowerCase();

    if (key === 'f12') { event.preventDefault(); return; }

    // Ctrl+Shift+I / J / C / K  (Windows/Linux)
    if (event.ctrlKey && event.shiftKey && ['i', 'j', 'c', 'k'].includes(key)) {
      event.preventDefault(); return;
    }

    // Cmd+Option+I / J / C  (Mac)
    if (event.metaKey && event.altKey && ['i', 'j', 'c'].includes(key)) {
      event.preventDefault(); return;
    }

    // Ctrl+U (view source) / Ctrl+S (save page)
    if (event.ctrlKey && ['u', 's'].includes(key)) {
      event.preventDefault();
    }
  }

  constructor(
    private translate: TranslateService,
    private spinnerService: SpinnerService,
    private devtools: DevtoolsService
  ) {
    this.translate.currentLang = 'en';
    this.spinnerService.isLoading$.subscribe(loading => {
      this.loading = loading;
    });
  }

  ngOnInit(): void {
    if (environment.securityEnabled && !isMobileDevice()) {
      document.addEventListener('keydown', this.boundKeyHandler);
    }

    this.devtools.startMonitoring(() => this.showBlockedScreen());
  }

  private showBlockedScreen(): void {
    document.body.style.cssText =
      'margin:0;display:flex;align-items:center;justify-content:center;' +
      'height:100vh;background:#f5f5f5;font-family:sans-serif;';
    document.body.innerHTML = `
      <div style="text-align:center;padding:2rem;">
        <img src="assets/img/pulse-logo.svg" style="width:120px;margin-bottom:1.5rem" alt="logo"/>
        <h2 style="color:#c0392b;margin:0">Access Restricted</h2>
        <p style="color:#666;margin-top:0.5rem">
          Developer tools detected. For security purposes, access is temporarily disabled.
        </p>
        <p style="color:#666;margin-top:0.25rem">
          Please close developer tools and refresh the page.
        </p>
      </div>`;
  }

  ngOnDestroy(): void {
    document.removeEventListener('keydown', this.boundKeyHandler);
  }
}
